export { default } from './primary-color'
